module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/the-drum-marketing-awards-2018/"},"frontmatter":{"title":"The Drum Marketing Awards 2018","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1200x1200_rla_social_drumawards-8dcd58fd8aaae6c5c92ed7788bcb8f2b.jpg"}}},"original":"/img/1200x1200_rla_social_drumawards.jpg"},"category":"News"}}}]}},"pathContext":{"tag":"AWARDS"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-awards.json
// module id = 1809
// module chunks = 146488754617562